import Migration from './Migration';

export default Migration;
